var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0059,
    cy: 11.7573,
    r: 9.375,
    transform: "rotate(90 12.0059 11.7573)",
    fill: "#FCFEFF",
    stroke: "#1B1A1B",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_20310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2876 13.588L12.1718 9.85876",
    stroke: "#1B1A1B",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0566 13.588L12.1724 9.85876",
    stroke: "#1B1A1B",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_20310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.77778,
    height: 16,
    fill: "white",
    transform: "matrix(8.74228e-08 -1 -1 -8.74228e-08 20.0059 16.7632)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowUp);
export default __webpack_public_path__ + "static/media/circle-arrow-up.5c9886caf9a712148fcfa3d49ada7f3d.svg";
export { ForwardRef as ReactComponent };